import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const ButtonContainer = styled.button`
  ${tw`flex`}
`;
